import { render, staticRenderFns } from "./halloween-loader.vue?vue&type=template&id=0d860a75&scoped=true"
import script from "./halloween-loader.vue?vue&type=script&lang=js"
export * from "./halloween-loader.vue?vue&type=script&lang=js"
import style0 from "./halloween-loader.vue?vue&type=style&index=0&id=0d860a75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d860a75",
  null
  
)

export default component.exports